import { render, staticRenderFns } from "./RusGrammar.vue?vue&type=template&id=be383bbe"
import script from "./RusGrammar.vue?vue&type=script&lang=js"
export * from "./RusGrammar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports